<template>
  <section v-show="hasItems" class="selected-filters">
    <h3 class="selected-filters__title">
      {{ _T("@Selected filters") }}
    </h3>
    <div class="selected-filters__container">
      <ul class="selected-filters__list">
        <SelectedFilterItem
          v-for="{ key, label, handler } in items"
          :key="key"
          @click="handler"
        >
          {{ label }}
        </SelectedFilterItem>
      </ul>
      <div class="selected-filters__clear" @click="resetItems">
        {{ _T("@Clear filters") }}
      </div>
    </div>
  </section>
</template>

<script setup>
import SelectedFilterItem from "~/modules/productCatalog/ui/components/filter/selected/SelectedFilterItem.vue";
import { useSelectedFilter } from "~/modules/productCatalog/composables/useSelectedFilter";

const { items, hasItems, resetItems } = useSelectedFilter();
</script>

<style lang="scss" scoped></style>
